/**
 * Custom lazy load function
 * @param {node} element - Node target to listenner
 * @param {function} cb custom callback
 * @param {object} options - IntersectionObserver options
 * @author Daniel Santos
 */
export function lazyLoad(element, cb, options = {
  rootMargin: '200px',
  threshold: 0,
}) {

  if (!element) return;

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          cb(observer)
        }
      });
    }, options)

    observer.observe(element)
  } else {
    cb(observer)
  }
}
